export default function useLayerListeners(layerInstance: LooseObject, listenerList: LayerListener[]) {
  listenerList.forEach((listener: LayerListener) => {
    layerInstance.on(listener.eventName, (...args) => {
      listener.callbackList?.forEach((fn) => {
        typeof fn === 'function' && fn?.(...args);
      });
    });
  });
}
